/**
 * Sets the document title with a consistent format
 * @param {string} title - The page-specific title
 */
export const setPageTitle = (title) => {
  document.title = title ? `JuhariTrading - ${title}` : 'JuhariTrading';
};

/**
 * Reset the document title to the default
 */
export const resetPageTitle = () => {
  document.title = 'JuhariTrading';
}; 